import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { LoadingButton } from '@mui/lab';
import { Button, Link, Paper, Stack, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import * as React from 'react';
import { shallowEqual } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { activateSiC } from '../../asyncHelpers/configService';
import { MinimalPageLayout } from '../../components/Navigation/MinimalLayout/MinimalPageLayout';
import { ButtonLogout } from '../../components/Shared/ButtonLogout';
import { StayInContactIcon } from '../../components/Shared/StayInContactIcon';
import { ButtonStopImpersonating } from '../../components/Support/ButtonStopImpersonating';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { requestConfig } from '../../store/users';

interface Params {}

export default function ActivateSiCPage({}: Params) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const [errorText, setErrorText] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const user = useAppSelector(state => {
        return state.user;
    }, shallowEqual);

    const handleActivate = async () => {
        try {
            setLoading(true);
            setErrorText('');
            await activateSiC();
            dispatch(requestConfig());
        } catch (e: any) {
            setLoading(false);
            if (!axios.isCancel(e)) {
                if (axios.isAxiosError(e)) {
                    if (e.response?.status == 400) {
                        setErrorText(e.response.data);
                    }
                }
            }
        }
    };

    return (
        <MinimalPageLayout>
            <StayInContactIcon className={classes.icon} />
            <Paper className={classes.root}>
                <Typography variant="h2" className={classes.title} m={4}>
                    Welcome to StayInContact, {user.userFirstName}
                </Typography>
                <Typography variant="body1" className={classes.status} m={2}>
                    Track and manage all conversation activity in one unified inbox for your whole
                    team.
                </Typography>
                <Typography variant="body1" className={classes.status} m={2}>
                    Tap to activate <strong>StayInContact</strong> for your user and import your
                    existing EngageCRM settings.
                </Typography>
                {errorText && (
                    <Typography variant="h6" className={classes.error}>
                        {errorText}
                    </Typography>
                )}
                <Stack spacing={2} direction="row" m={4}>
                    <LoadingButton
                        variant="contained"
                        size="large"
                        startIcon={<RocketLaunchIcon />}
                        onClick={handleActivate}
                        loading={loading}
                        loadingPosition="start"
                    >
                        Activate
                    </LoadingButton>
                    <Link href="https://stayincontact.com/" target="_blank">
                        <Button variant="outlined" size="large" startIcon={<OpenInNewIcon />}>
                            Learn More
                        </Button>
                    </Link>
                    <ButtonLogout variant="outlined" size="large" />
                    <ButtonStopImpersonating />
                </Stack>
            </Paper>
        </MinimalPageLayout>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.up('xs')]: {
            maxWidth: '30rem',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '50rem',
        },
    },
    icon: {
        maxWidth: '250px',
    },
    status: {
        // marginTop: '16px',
        // color: '#fff'
    },
    title: {
        textAlign: 'center',
    },
    error: {
        color: 'red',
    },
}));
